// extracted by mini-css-extract-plugin
module.exports = {"text-ad":"_2wvn-8"};